function collapseSection(element) {
    var sectionHeight = element.scrollHeight,
        elementTransition = element.style.transition;

    element.style.transition = '';

    requestAnimationFrame(function() {
        element.style.height = sectionHeight + 'px';
        element.style.transition = elementTransition;

        requestAnimationFrame(function() {
            element.style.height = 0 + 'px';
        });
    });

    element.setAttribute('data-collapsed', 'true');
}

function expandSection(element) {
    var sectionHeight = element.scrollHeight;
    
    element.style.height = sectionHeight + 'px';

    element.addEventListener('transitionend', function(e) {
        element.removeEventListener('transitionend', arguments.callee);
        element.style.height = null;
    });
    
    element.setAttribute('data-collapsed', 'false');
}


function init_timeline() {
    var toggle_button = document.getElementsByClassName('toggle-button'), i, button_url_open, button_url_close;

    for ( i=0; i<toggle_button.length; i++) {
        if ( i == 0 ) {
            button_url_open = toggle_button[i].dataset.buttonOpen,
            button_url_close = toggle_button[i].dataset.buttonClose;
        }

        toggle_button[i].addEventListener('click', function() {
    
            var section = this.parentNode.nextElementSibling.querySelector('.text-panel.collapsible'),
                isCollapsed = section.getAttribute('data-collapsed') === 'true';
    
            if(isCollapsed) {
                expandSection(section);
                this.querySelector('img').src = button_url_close;
                section.setAttribute('data-collapsed', 'false');
            } else {
                collapseSection(section);
                this.querySelector('img').src = button_url_open;
            }
        });
    }
}

if (document.addEventListener) {
    document.addEventListener("DOMContentLoaded", init_timeline, false);
} else {
    window.onload = function () {
        init_timeline();
    }
}
